import React, {useEffect} from 'react';
import { useLayoutContext } from '../../providers/LayoutProvider';
import './Header.scss';
import { LoginBar } from './LoginBar/LoginBar';
import { NavigationBar } from './Navigation/NavigationBar';
import { PromoBar } from './PromoBar/PromoBar';
import { SearchBar } from './SearchBar/SearchBar';
import { datadogRum } from '@datadog/browser-rum';

export const Header = ({ isHomepage, isScrolled, promoBar }) => {
    const { searchOpen } = useLayoutContext();

    useEffect(() => {
        
        datadogRum.init({
            applicationId: `c9e6b761-c184-4528-8ba9-07c78d3e1b23`,
            clientToken: `pub223d70f2c92f4544fe261eed4cd26fa7`,
            site: `datadoghq.com`,
            service: `reach`,
            env: `${process.env.GATSBY_DD_RUM_ENV}`,
            sessionSampleRate: 70,
            sessionReplaySampleRate: 20,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel: `mask-user-input`,
        });

        datadogRum.startSessionReplayRecording();
    }, []);

    return (
        <header
            className={`site-header ${isHomepage ? `homepage` : ``} ${
                isScrolled ? `scr` : ``
            } ${isHomepage && !isScrolled ? `dark` : `light`}`}
        >
            {promoBar && <PromoBar promoBar={promoBar} />}
            <LoginBar />
            <NavigationBar darkBgLogo={isHomepage && !isScrolled} />
            {searchOpen && <SearchBar />}
        </header>
    );
};
